module.exports = __webpack_public_path__ + "img/customer.0135ce14.png";